import _action from './action';
export { _action as action };

import _Store from './store';
export { _Store as Store };

import translator from './translator';
export { translator as _ };

import _React, { Component as _Component } from 'react';
export { _React as React, _Component as Component };

import _PropTypes from 'prop-types';
export { _PropTypes as PropTypes };

import { Container as _Container } from 'flux/utils';
export { _Container as Container };

import { waitFor as _waitFor } from './dispatcher';
export { _waitFor as waitFor };

import { BrowserRouter, Link as _Link, Route as _Route } from 'react-router-dom';
export { BrowserRouter as Router, _Link as Link, _Route as Route };

import _config, { setup as _setup } from './config';
export { _config as Config, _setup as setup };

import _Icon from './icon';
export { _Icon as Icon };

import _Modal from './Modal';
export { _Modal as Modal };

import _Header from './Header';
export { _Header as Header };

import _Body from './Body';
export { _Body as Body };

import { CSSTransition } from 'react-transition-group';
export { CSSTransition as Transition };


// WEBPACK FOOTER //
// ./src/modules/utils/index.js